// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKvBNb2YgZd5-glyNSBxWHJWeMYztOpjI",
  authDomain: "the-laboratory-f34ec.firebaseapp.com",
  projectId: "the-laboratory-f34ec",
  storageBucket: "the-laboratory-f34ec.appspot.com",
  messagingSenderId: "458701361093",
  appId: "1:458701361093:web:479a67632f888dccba45ac",
  measurementId: "G-3GJWPG23YP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
export const db = getFirestore();
export const auth = getAuth();
export const login = signInWithEmailAndPassword;


